export default __webpack_public_path__ + "static/media/waste-water.0eda9035.jpg";